import React from 'react'
import AppUpdateWrapper from './AppUpdateWrapper'
import { REQUIRED_KEYCLOAK_APP_VERSION_IOS } from '../const'
import { useFeatureFlagsContext } from 'src/Libs/feature-flags/FeatureFlagsContext'

interface Props {
  children: React.ReactNode
}

/**
 * Wrapper which either shows the app content or enforces an iOS app update by displaying the update page instead.
 */
const EnforceIosUpdateWrapper: React.FC<Props> = ({ children }) => {
  const {
    featureFlags: { isEnforcingIosAppUpdate },
    isFeatureFlagsLoading,
    isFeatureFlagsError,
  } = useFeatureFlagsContext()

  if (isFeatureFlagsError) return children
  if (isFeatureFlagsLoading) return null
  return (
    <AppUpdateWrapper requiredAppVersion={{ e3dc: REQUIRED_KEYCLOAK_APP_VERSION_IOS }} activeForIos={isEnforcingIosAppUpdate}>
      {children}
    </AppUpdateWrapper>
  )
}

export default EnforceIosUpdateWrapper
